import React, { useState } from 'react';
import { Bell, CheckCircle, Plane, AlertTriangle, Clock, ChevronRight, Check } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
export function NotificationsPage() {
  const {
    notifications,
    markAllNotificationsRead
  } = useAppContext();
  const [activeFilter, setActiveFilter] = useState('All');
  const getIcon = (type: string) => {
    switch (type) {
      case 'approval':
        return CheckCircle;
      case 'booking':
        return Plane;
      case 'policy':
        return AlertTriangle;
      case 'system':
        return Bell;
      default:
        return Bell;
    }
  };
  const getColor = (type: string) => {
    switch (type) {
      case 'approval':
        return 'bg-emerald-100 text-emerald-600';
      case 'booking':
        return 'bg-blue-100 text-blue-600';
      case 'policy':
        return 'bg-amber-100 text-amber-600';
      case 'system':
        return 'bg-slate-100 text-slate-600';
      default:
        return 'bg-slate-100 text-slate-600';
    }
  };
  const filteredNotifications = activeFilter === 'All' ? notifications : notifications.filter(n => {
    if (activeFilter === 'Approvals') return n.type === 'approval';
    if (activeFilter === 'Bookings') return n.type === 'booking';
    if (activeFilter === 'Policy') return n.type === 'policy';
    if (activeFilter === 'System') return n.type === 'system';
    return true;
  });
  return <div className="space-y-6" data-id="element-982">
      <div className="flex items-center justify-between" data-id="element-983">
        <div data-id="element-984">
          <h2 className="text-2xl font-bold text-slate-800" data-id="element-985">Notifications</h2>
          <p className="text-slate-500" data-id="element-986">
            Stay updated on your travel activity.
          </p>
        </div>
        <button onClick={markAllNotificationsRead} className="flex items-center rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-987">
          <Check className="mr-2 h-4 w-4" data-id="element-988" />
          Mark All Read
        </button>
      </div>

      {/* Filters */}
      <div className="flex gap-2 overflow-x-auto pb-2" data-id="element-989">
        {['All', 'Approvals', 'Bookings', 'Policy', 'System'].map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`
              rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition-colors
              ${activeFilter === filter ? 'bg-blue-600 text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}
            `} data-id="element-990">
            {filter}
          </button>)}
      </div>

      {/* Notification List */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm divide-y divide-slate-100" data-id="element-991">
        {filteredNotifications.length > 0 ? filteredNotifications.map(notification => {
        const Icon = getIcon(notification.type);
        const colorClass = getColor(notification.type);
        return <div key={notification.id} className={`p-4 flex items-start gap-4 hover:bg-slate-50 transition-colors ${!notification.read ? 'bg-blue-50/30' : ''}`} data-id="element-992">
                <div className={`mt-1 h-10 w-10 rounded-full flex items-center justify-center flex-shrink-0 ${colorClass}`} data-id="element-993">
                  <Icon className="h-5 w-5" data-id="element-994" />
                </div>

                <div className="flex-1 min-w-0" data-id="element-995">
                  <div className="flex items-center justify-between mb-1" data-id="element-996">
                    <h3 className={`text-sm font-semibold ${!notification.read ? 'text-slate-900' : 'text-slate-700'}`} data-id="element-997">
                      {notification.title}
                    </h3>
                    <span className="text-xs text-slate-400 whitespace-nowrap ml-2" data-id="element-998">
                      {notification.time}
                    </span>
                  </div>
                  <p className="text-sm text-slate-600 mb-2" data-id="element-999">
                    {notification.desc}
                  </p>
                  {notification.action && <button className="text-sm font-medium text-blue-600 hover:text-blue-700 flex items-center" data-id="element-1000">
                      {notification.action}{' '}
                      <ChevronRight className="h-3 w-3 ml-1" data-id="element-1001" />
                    </button>}
                </div>

                {!notification.read && <div className="mt-2 h-2.5 w-2.5 rounded-full bg-blue-600 flex-shrink-0" data-id="element-1002"></div>}
              </div>;
      }) : <div className="p-12 text-center text-slate-500" data-id="element-1003">
            <Bell className="h-12 w-12 mx-auto text-slate-300 mb-3" data-id="element-1004" />
            <p data-id="element-1005">No notifications found</p>
          </div>}
      </div>
    </div>;
}